import React, { useRef, useEffect } from "react";
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import { oneDark } from "react-syntax-highlighter/dist/esm/styles/prism";
import CopyButton from "./CopyButton"; // Import the new CopyButton component

const MessageList = React.memo(({ messages, styles }) => {
  const messagesEndRef = useRef(null);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  return (
    <div style={styles.messagesContainer}>
      {messages.map((message, index) => (
        <div
          key={index}
          style={{
            ...styles.chatBubble,
            ...(message.sender === "user"
              ? styles.userBubble
              : styles.botBubble),
          }}
        >
          {message.sender === "bot" ? (
            <ReactMarkdown
              className={styles.markdownText}
              rehypePlugins={[rehypeRaw]}
              components={{
                code({ node, inline, className, children, ...props }) {
                  const match = /language-(\w+)/.exec(className || "");
                  return !inline && match ? (
                    <div>
                      <CopyButton code={String(children)} /> {/* Add Copy Button */}
                      <SyntaxHighlighter
                        style={oneDark}
                        language={match[1]}
                        PreTag="div"
                        showLineNumbers={false}
                        {...props}
                      >
                        {String(children)}
                      </SyntaxHighlighter>
                    </div>
                  ) : (
                    <code style={styles.codeBlock} {...props}>
                      {children}
                    </code>
                  );
                },
                pre({ children, ...props }) {
                  return (
                    <pre style={styles.pre} {...props}>
                      {children}
                    </pre>
                  );
                },
              }}
            >
              {message.text}
            </ReactMarkdown>
          ) : (
            message.text
          )}
        </div>
      ))}
      <div ref={messagesEndRef} />
    </div>
  );
});

export default MessageList;